<template>
  <div class="account-list" :class="{ 'multiple': type == 2 }">
    <div class="header">
      <div class="header-item">账户</div>
      <div class="header-item">
        <div>下单手数</div>
        <div
          class="icon-container"
          v-if="type == 2"
          role="button"
          tabindex="0"
          @click="handleClick"
        >
          <van-icon name="edit" />
        </div>
      </div>
    </div>
    <div
      class="account-item"
      v-for="(account, index) in accounts"
      :key="`${account.value}${index}`"
    >
      <div class="account-info">{{ account.text }}</div>
      <div class="order-count">
        {{ calculateAccountCount(account.multiple) }}
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    accounts: {
      type: Array,
      required: true
    },
    count: {
      type: [Number, String],
      default: 5
    },
    multiplier: {
      type: Number,
      default: 1
    }
  },
  components: {
    [Icon.name]: Icon
  },
  computed: {
    // 根据类型计算账户数量
    calculateAccountCount() {
      return multiple => {
        const countAsNumber = Number(this.count);
        if (isNaN(countAsNumber) || typeof this.type === "undefined") {
          
          return 0;
        }
        // 处理 multiple 未定义的情况
        if (typeof multiple === "undefined") {
          
          return 0;
        }
        return this.type === 1
          ? countAsNumber
          : Math.floor(multiple * countAsNumber);
      };
    }
  },
  methods: {
    handleClick() {
      this.$emit("markMultiple");
      this.$router.push("/h5-page-account?activeIndex=1");
    }
  }
};
</script>

<style lang="less" scoped>
.account-list {
  border-radius: 4px;
  font-family: Arial, sans-serif;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 14px 24px;
    font-weight: bold;
    border-bottom: 1px solid #f4f5f6;

    .header-item {
      display: flex;
      // justify-content: center;
      width: 70%;
      text-align: left;
      .icon-container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 8px;
      }
      &:last-child {
        display: flex;
        justify-content: flex-end;
        width: 30%;
        text-align: right !important;
      }
    }
  }

  .account-item {
    display: flex;
    justify-content: space-between;
    padding: 14px 24px;
    border-bottom: 1px solid #f4f5f6;

    &:last-child {
      border-bottom: none;
    }
    .account-info {
      width: 70% !important;
      text-align: left;
    }
    .account-info,
    .order-count {
      width: 30%;
      white-space: nowrap;
      font-size: 26px;
    }
    .order-count {
      text-align: right;
      padding-right: 38px; 
    }
  }
  &.multiple {
    .order-count {
      padding-right: 68px; 
    }
  }
}
</style>
